export const SCENARIO_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "recent_activity", label: "Recent activity" },
] as const;

export type ScenarioSortKey = (typeof SCENARIO_SORT_OPTIONS)[number]["value"];

export interface OutlineListItem {
  id: string;
  name: string;
  tension?: string | null;
  description: string | null;
  narrative: string | null;
  taskCriticality?: string | null;
  humanTests?: Array<{ id: string; question: string }> | null;
  createdAt: string | Date;
  lastWalkthroughAt?: string | Date | null;
  walkthroughCount?: number;
  findingCount?: number;
  primaryCapabilityId?: string | null;
  additionalCapabilityIds?: string[];
  personaVerdicts: Array<{
    personaId: string;
    personaName: string;
    scenarioId: string;
    verdict: unknown;
    runCount: number;
    completedAt: string | null;
    openFindingCount?: number;
    criticalOpenCount?: number;
    hasCriticalOpen?: boolean;
  }>;
}
